import React from "react";
import HoverButton from "./HoverButton";
import useResponsive from "./useResponsive";
import { resolveDirection } from "./Stack";
import CenteredMarkdown from "./CenteredMarkdown";

function PreviewCard({
	children,
	image,
	title,
	titleLevel = "h2",
	titleStyle,
	description,
	buttonText,
	config,
	onButtonClick,
	style,
	imageContainerStyle,
	imageStyle,
	direction = "h",
	itemsStyle,
	notificationImage,
}) {
	const isMobile = useResponsive();
	const resolvedDirection = resolveDirection(direction, isMobile);
	const TitleTag = titleLevel;

	return (
		<div
			className="CardComponent"
			style={{
				minWidth: "200px",
				margin: "10px",
				borderRadius: "30px",
				padding: "10px",
				background: config.colors.background,
				boxShadow: `-2px -2px 10px rgba(255, 255, 255,0.1), 3px 3px 5px rgba(0, 0, 0, 0.1)`,
				overflow: "hidden",
				...style,
			}}
		>
			<div
				style={{
					display: "flex",
					flexDirection: resolvedDirection === "h" ? "row" : "column",
					width: "100%",
					height: "100%",
					...itemsStyle,
				}}
			>
				{image && (
					<div
						className="imageContainer"
						style={{
							position: "relative",
							padding: "5px",
							width: "100%",
							display: "flex",
							...imageContainerStyle,
						}}
					>
						<img
							onClick={onButtonClick}
							src={image}
							alt={title}
							style={{
								objectFit: "cover",
								borderRadius: "15px",
								maxHeight: "calc(100vh - 300px)",
								margin: "5px",
								boxShadow: `-2px -2px 5px rgba(200, 200, 200,0.3), 3px 3px 5px rgba(77, 77, 77, 0.6)`,
								...imageStyle,
							}}
						/>
						{notificationImage && (
							<div style={{ position: "absolute", top: "10px", right: "10px" }}>
								<img
									src={notificationImage}
									alt="Filter"
									style={{
										height: "50px",
										width: "50px",
										borderRadius: "10px",
										boxShadow: `-2px -2px 5px rgba(149, 208, 255,0.3), 3px 3px 5px rgba(0, 0, 0, 0.3)`,
									}}
								/>
							</div>
						)}
					</div>
				)}
				<div
					className="textContainer"
					style={{
						padding: "10px",
						paddingLeft: resolvedDirection === "h" ? "10px" : "0px",
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
						textAlign: "center",
						width: "100%",
					}}
				>
					{title && (
						<TitleTag
							style={{
								color: config.colors.darkAccent,
								whiteSpace: "pre-wrap",
								width: "100%",
								textAlign: "center",
								marginBottom: "0px",
								fontSize: "20px",
								fontWeight: 700,
								...titleStyle,
							}}
						>
							{title}
						</TitleTag>
					)}
					{description && <CenteredMarkdown markdown={description} />}
					{children}
					{buttonText && (
						<HoverButton config={config} onClick={onButtonClick}>
							{buttonText}
						</HoverButton>
					)}
				</div>
			</div>
		</div>
	);
}

export default PreviewCard;
